import Icon from '@/components/ui/AppIcon';

interface UseCase {
  id: string
  icon: string
  label: string
  color: string
}

const BusinessUseCasesSection = () => {
  const useCases: UseCase[] = [
    { id: 'use_pizza', icon: 'fire', label: 'Pizza', color: 'bg-red-100 text-red-600' },
    { id: 'use_tacos', icon: 'sparkles', label: 'Tacos', color: 'bg-yellow-100 text-yellow-600' },
    { id: 'use_burgers', icon: 'star', label: 'Burgers', color: 'bg-orange-100 text-orange-600' },
    { id: 'use_icecream', icon: 'heart', label: 'Ice Cream', color: 'bg-pink-100 text-pink-600' },
    { id: 'use_coffee', icon: 'beaker', label: 'Coffee', color: 'bg-amber-100 text-amber-700' },
    { id: 'use_beverages', icon: 'gift', label: 'Beverages', color: 'bg-blue-100 text-blue-600' },
  ]

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="reveal text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold font-montserrat text-foreground mb-6">
            Perfect for <span className="text-primary">Entrepreneurs</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Ready to open or expand your food business? Our containers are built for success.
          </p>
        </div>

        {/* Use Cases Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {useCases.map((useCase, index) => (
            <div
              key={useCase.id}
              className="reveal group"
              style={{ animationDelay: `${0.1 * (index + 1)}s` }}
            >
              <div className="flex flex-col items-center text-center p-6 rounded-2xl border border-gray-200 hover:border-primary hover:shadow-lg transition-all cursor-pointer bg-white">
                {/* Icon Circle */}
                <div className={`w-20 h-20 rounded-full ${useCase.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {useCase.icon === 'fire' && (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                    )}
                    {useCase.icon === 'sparkles' && (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                    )}
                    {useCase.icon === 'star' && (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                    )}
                    {useCase.icon === 'heart' && (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    )}
                    {useCase.icon === 'beaker' && (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                    )}
                    {useCase.icon === 'gift' && (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                    )}
                  </svg>
                </div>

                {/* Label */}
                <h3 className="font-semibold text-foreground">{useCase.label}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default BusinessUseCasesSection